import { HStack, ImageFallback, Text } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { TextSkeleton } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export interface LogoWithNameProps {
  name: string;
  logoUrl: string;
}

export const LogoWithName: React.FC<LogoWithNameProps> = ({ name, logoUrl }) => {
  return (
    <HStack space="inline.nano" alignItems="center" flex={1}>
      <ImageFallback
        src={logoUrl}
        alt={`${name}-logo`}
        width="32px"
        height="32px"
        testID="product-img"
        resizeMode="cover"
        borderRadius={BoxRadius.sm}
        resizeMethod="scale"
      />
      <Text>{name}</Text>
    </HStack>
  );
};

export const LogoWithNameLoading: React.FC = () => {
  return (
    <HStack space="inline.nano" alignItems="center" flex={1}>
      <ImageFallback
        src=""
        alt="logo-placeholder"
        width="32px"
        height="32px"
        testID="product-img"
        resizeMode="cover"
        borderRadius={BoxRadius.sm}
        resizeMethod="scale"
      />
      <TextSkeleton w="60px" />
    </HStack>
  );
};
